export default __webpack_public_path__ + "assets/logo.103b5fa1.svg";